var map = {
	"./auoas.jpg": 151,
	"./buckingham.jpg": 152,
	"./bundesministerium.jpg": 153,
	"./ebs.jpg": 154,
	"./esf.jpg": 155,
	"./eu_commission.jpg": 156,
	"./eu_institute.jpg": 157,
	"./exist.jpg": 158,
	"./foggia.jpg": 159,
	"./gesis.jpg": 160,
	"./glu.jpg": 161,
	"./heidelberg.jpg": 162,
	"./hertie.jpg": 163,
	"./htw_berlin.jpg": 164,
	"./itmo.png": 165,
	"./jacobs.jpg": 166,
	"./jgu.jpg": 167,
	"./kit.jpg": 168,
	"./land_der_ideen.jpg": 169,
	"./luiss.jpg": 170,
	"./mhmk.jpg": 171,
	"./open_education.jpg": 172,
	"./osnabrueck.jpg": 173,
	"./padova.jpg": 174,
	"./passau.jpg": 175,
	"./pavia.jpg": 176,
	"./pfur.jpg": 177,
	"./reutlingen.jpg": 178,
	"./rwth.jpg": 179,
	"./salford.jpg": 180,
	"./stifterverband.jpg": 181,
	"./tpu.jpg": 182,
	"./tsu.jpg": 183,
	"./tusur.jpg": 184,
	"./udima.jpg": 185,
	"./unep.jpg": 186,
	"./usi.jpg": 187,
	"./whu.jpg": 188,
	"./wwf.jpg": 189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;